import { useLocation } from "react-router-dom";

const CommercialHeader = () => {
  const location = useLocation(); // Get current URL
  const params = new URLSearchParams(location.search);
  const category = params.get("category") || "commercial";

  // Map category to human-readable headings
  const categoryTextMap = {
    retail: "Retail Properties",
    multi_family: "Multi-Family Apartments",
    office_building: "Office Buildings",
    industrial: "Industrial Properties",
  };

  // Decide heading text dynamically
  const headingText =
    categoryTextMap[category]
      ? categoryTextMap[category]
      : "Commercial Properties";

      

  return <h6 className="mb-0">{headingText}</h6>;
};

export default CommercialHeader;
